// import auth from '../auth';
// import rest from '../rest'

// const serverUrl = process.env.VUE_APP_ROOT_API_SERVER_URL;

// const tokenRequest = {
//   scopes: ['api://6368fbe9-214c-4939-9499-7b8d96653f21/User.ReadWrite'],
//   forceRefresh: false // set this to "true" if you would like to skip a cached token and go to the server
// };

export default {
  // async downloadCsv(payload) {
  //   const url = `${serverUrl}/file/downloadcsv`;
  //   const options = await auth.getOptions(tokenRequest, 'POST', JSON.stringify(payload), true);

  //   await rest.callForFileDownload(url, options, payload.csvFileName);
  // },

  downloadCsvLocal(filename, data) {
    var a = document.createElement("a");
    a.download = filename;

    var blob  = new Blob([data], {type: "text/csv"});

    a.href = window.URL.createObjectURL(blob);
    a.click();
    a.remove();
  }
}